import { useEffect } from 'react';
import { apiCall } from './auth';

// Consulta o status dos registros de tempos em tempos e recarrega a página inteira quando algum
// passa para o status final (orçamento aprovado pelo link, contrato assinado), mesmo com formulário aberto.
// Só consulta com a aba visível; ao voltar para a aba, consulta na hora.
export default function useRecarregarQuandoConcluir(endpoint, ehConcluido, intervaloMs = 15000) {
  useEffect(() => {
    let anterior = null; // { id: concluido }
    let parado = false;

    const verificar = async () => {
      if (parado || document.hidden) return;
      try {
        const lista = await apiCall(endpoint);
        const atual = {};
        (Array.isArray(lista) ? lista : []).forEach(item => {
          const id = item.id ?? item.Id;
          if (id != null) atual[id] = ehConcluido(item);
        });
        if (anterior) {
          const concluiuAgora = Object.keys(atual).some(id => atual[id] && anterior[id] === false);
          if (concluiuAgora) {
            window.location.reload();
            return;
          }
        }
        anterior = atual;
      } catch {
        // sem conexão ou sessão expirada: tenta de novo na próxima
      }
    };

    verificar();
    const timer = setInterval(verificar, intervaloMs);
    const aoVoltarParaAba = () => { if (!document.hidden) verificar(); };
    document.addEventListener('visibilitychange', aoVoltarParaAba);
    return () => {
      parado = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', aoVoltarParaAba);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, intervaloMs]);
}
